// removed by extract-text-webpack-plugin
module.exports = {"header":"page__header--2dK_F","userName":"page__userName--25kJ1"};


//////////////////
// WEBPACK FOOTER
// ./src/client/plugins/onboarding/pages/profile-entry/styles/page.scss
// module id = MTIN
// module chunks = 23